import { render } from "./HeaderHome.vue?vue&type=template&id=b2638e0c&scoped=true&ts=true"
import script from "./HeaderHome.vue?vue&type=script&lang=ts"
export * from "./HeaderHome.vue?vue&type=script&lang=ts"

import "./HeaderHome.vue?vue&type=style&index=0&id=b2638e0c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2638e0c"]])

export default __exports__